/** Accepts Object type and returns a union of its' own property values */
export type ValuesOf<T extends Record<any, string | number>> = T[keyof T];

/** Creates key-value pair object type from provided string union */
export type ConstantOf<T extends string> = Readonly<Record<Uppercase<T>, T>>;
